export const Paw = ({ className = "" }) => (
  <svg viewBox="0 0 64 64" className={className} fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <ellipse cx="12" cy="28" rx="7" ry="9.5" transform="rotate(-20 12 28)" />
    <ellipse cx="25" cy="15" rx="6.5" ry="9.5" />
    <ellipse cx="39" cy="15" rx="6.5" ry="9.5" />
    <ellipse cx="52" cy="28" rx="7" ry="9.5" transform="rotate(20 52 28)" />
    <path d="M32 28C19 28 12.5 39 15.5 48.5C18.3 57.3 26 60 32 60C38 60 45.7 57.3 48.5 48.5C51.5 39 45 28 32 28Z" />
  </svg>
);
